import React from 'react';
import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { OperacionLCTC } from "../types/types";
import { OperacionLCTCFields } from '../types/fields';
import { dateFormatter } from "src/utils/formatters";

type SeccionLCTCDatosOperacionProps = {
    operacion?: OperacionLCTC;
}

const SeccionLCTCDatosOperacion = ({ operacion }: SeccionLCTCDatosOperacionProps) => {
    return (
        <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
            {operacion && (
                <SectionBox>
                    <Grid item xs={12} md={2}>
                        <FieldView label='País' value={operacion[OperacionLCTCFields.NombrePais]} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView
                            label='Usuario Alta'
                            value={`${operacion[OperacionLCTCFields.NombreUsuarioAlta]} ${operacion[OperacionLCTCFields.ApellidoUsuarioAlta]}`}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView label='Unidad de Negocio' value={operacion[OperacionLCTCFields.DescUnidadNegocio]} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView label='Equipo Comercial' value={operacion[OperacionLCTCFields.DescSectorComercial]} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView
                            label='Fecha de Solicitud'
                            value={operacion[OperacionLCTCFields.FechaSolicitud]
                                ? dateFormatter.toShortDate(operacion[OperacionLCTCFields.FechaSolicitud])
                                : undefined}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FieldView
                            label='Fecha de Vencimiento'
                            value={operacion[OperacionLCTCFields.FechaVencimiento]
                                ? dateFormatter.toShortDate(operacion[OperacionLCTCFields.FechaVencimiento])
                                : undefined}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FieldView label='Observaciones' value={operacion[OperacionLCTCFields.Observaciones]} />
                    </Grid>
                </SectionBox>
            )}
        </CardActions>
    );
}

export default SeccionLCTCDatosOperacion;